<template>
  <div>
    <div v-if="loadingFornecedoresProdutos">
      <px-circular-loading/>
    </div>
    <template v-if="!loadingFornecedoresProdutos">
      <px-lista-fornecedor-header ref="listHeader"
                                  :values="value"
                                  :initial-selection-count="initialSelectionCount"
                                  @change="onChangeFilter"
                                  @resetfornecedor="emitReset"
                                  @remove="onRemoveFornecedor"/>
      <div v-if="firstAccess" class="d-flex flex-column align-center mt-12 mb-12">
        <v-img
          src="../../assets/search.jpg"
          max-height="150px"
          height="150px"
          max-width="150px"
        ></v-img>
        <div class="mt-10">
          Faça um
          <v-btn text class="normal-btn-text rounded-tag-small px-0 mx-0"
                 color="primary"
                 @click="openFilters">
            filtro
          </v-btn>
          ou uma
          <v-btn text class="normal-btn-text rounded-tag-small px-0 mx-0"
                 color="primary"
                 @click="focusOnSearchText">
            busca
          </v-btn>
          para encontrar fornecedores
        </div>
      </div>
      <px-lista-fornecedor-list v-if="!firstAccess"
                                :fornecedores="fornecedores"
                                :options-list="optionsList"
                                :loading="loading"
                                v-model="localValue"
                                :on-change-options="onChangeOptions"/>
    </template>
  </div>
</template>

<script>
import { isEmpty } from 'lodash';
import FornecedorService from '@/api/fornecedor-service';
import paginationMixin from '@/mixins/pagination-mixin';
import { hasAnyLetter, formatCnpj } from '@/utils/regex-utils';
import PxListaFornecedorList from './PxListaFornecedorList.vue';
import PxListaFornecedorHeader from './PxListaFornecedorHeader.vue';

export default {
  mixins: [paginationMixin],
  props: {
    value: Array,
    produtos: Array,
    isEditing: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      initialSelectionCount: 0,
      firstAccess: true,
      filters: {
        searchText: null,
        estados: [],
        municipios: [],
        cnaes: [],
      },
      loading: false,
      loadingFornecedoresProdutos: false,
      fornecedores: {
        content: [],
        total: 0,
      },
      listOptions: {
        page: 1,
        limit: 10,
        offset: 0,
        filter: '',
        sort: 'nome',
        sortDesc: false,
      },
      optionsList: {},
    };
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(localValue) {
        this.$emit('input', localValue);
      },
    },
  },
  methods: {
    emitReset() {
      this.$emit('resetfornecedor');
    },
    buildStringFilter() {
      const cnpjQuery = !hasAnyLetter(this.filters.searchText) ? ` or cnpj like "${formatCnpj(this.filters.searchText)}%" or documento like "%${formatCnpj(this.filters.searchText)}%"` : '';
      const stringfilters = [];
      if (this.filters.searchText) {
        const searchTextFilter = `(nome like '%${this.filters.searchText.toLowerCase()}%' or nomeCustomizado like '%${this.filters.searchText.toLowerCase()}%'${cnpjQuery})`;
        stringfilters.push(searchTextFilter);
      }
      if (this.filters.municipios && this.filters.municipios.length) {
        const municipiosFilter = this.filters.municipios.map(municipio => `(municipio = ${municipio.id})`);
        stringfilters.push(`(${municipiosFilter.join(' or ')})`);
      }
      if (this.filters.estados && this.filters.estados.length) {
        const estadosFilter = this.filters.estados.map(estado => `(estado = ${estado.id})`);
        stringfilters.push(`(${estadosFilter.join(' or ')})`);
      }
      if (this.filters.cnaes && this.filters.cnaes.length) {
        const cnaesFilter = this.filters.cnaes.map(cnaes => `(cnae = ${cnaes.id})`);
        const cnaesSecundarioFilter = this.filters.cnaes.map(cnaes => `(cnae_secundario = ${cnaes.id})`);
        stringfilters.push(`(${cnaesFilter.join(' or ')} or ${cnaesSecundarioFilter.join(' or ')})`);
      }
      return stringfilters.join(' and ');
    },
    onChangeFilter(filters) {
      this.filters = filters;
      this.listOptions.filter = this.buildStringFilter();
      this.resetPage();
      if (!this.firstAccess) {
        this.getFornecedores();
      }
      this.firstAccess = false;
    },
    onChangeOptions(options) {
      this.optionsList = options;
      this.listOptions = this.optionsToPage(this.listOptions, this.optionsList);
      this.getFornecedores();
    },
    resetPage() {
      this.listOptions = this.resetPagination(this.listOptions);
      this.optionsList = this.pageToOptions(this.listOptions);
    },
    getFornecedores() {
      this.loading = true;
      const { limit, offset } = this.listOptions;
      FornecedorService.getFornecedoresScore({
        limit,
        offset,
        query: this.buildQuery(this.listOptions),
        codigoInterno: this.getFilterCodigoInterno(),
      })
        .then(({ data }) => {
          this.fornecedores = data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getFilterCodigoInterno() {
      if (this.filters.searchText) {
        return this.filters.searchText.trim();
      }
      return null;
    },
    getFilterProdutos() {
      if (isEmpty(this.produtos)) {
        return null;
      }
      const ids = this.produtos.filter(produto => !!produto.produto)
        .map(produto => produto.produto.id);
      return ids ? `${ids.join(',')}` : null;
    },
    getFornecedoresProdutos(produtoFilter) {
      this.loadingFornecedoresProdutos = true;
      FornecedorService.getFornecedoresScore({
        limit: 50,
        offset: 0,
        produtosGestao: produtoFilter,
      })
        .then(({ data }) => {
          if (data.content && data.content.length) {
            this.initialSelectionCount = data.content.length;
            this.localValue = data.content;
          }
        })
        .finally(() => {
          this.loadingFornecedoresProdutos = false;
          this.optionsList = this.pageToOptions(this.listOptions);
        });
    },
    onRemoveFornecedor(fornecedor) {
      this.localValue = this.localValue.filter(f => f.id !== fornecedor.id);
    },
    openFilters() {
      this.$refs.listHeader.openFilters();
    },
    focusOnSearchText() {
      this.$refs.listHeader.focusOnSearchText();
    },
  },
  created() {
    // se já tiver fornecedores selecionados, não fazemos a busca novamente
    if ((this.localValue && this.localValue.length) || this.isEditing) {
      this.optionsList = this.pageToOptions(this.listOptions);
      return;
    }
    const produtoFilter = this.getFilterProdutos();
    if (!produtoFilter || this.isEditing) {
      return;
    }
    this.getFornecedoresProdutos(produtoFilter);
  },
  components: {
    PxListaFornecedorList,
    PxListaFornecedorHeader,
  },
};
</script>
